import { PageHeader } from '@/components/PageHeader';
import { FeedbackTab } from '@/sections/users-and-agents/FeedbackTab';

export function FeedbackPage() {
  return (
    <>
      <PageHeader title="Feedback" description="Unresolved product feedback, bugs, and requests." />
      <div className="px-8 py-6">
        <FeedbackTab />
      </div>
    </>
  );
}
